var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isShowPc)?_c('head-vue',{ref:"headVue"}):_vm._e(),(_vm.isShowWap)?_c('head-wap'):_vm._e(),_c('content-vue'),(_vm.isShowPc)?_c('foot-vue'):_vm._e(),(_vm.isShowWap)?_c('foot-wap'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }